import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import JoinGame from '../JoinGame';
import {Panel, PulseLoader} from '../../../common';
import {appId} from '../../../../store';
import {forwardTo} from '../../../../utils';
import {youCantJoinFullGameMessage, youCantJoinMessage} from '../../../../configs/messages';
import {defaultToastProps, GAME_PHASE_PLAYING} from '../../../../configs/constants';

export default class JoinGameByDirectLink extends PureComponent {
  static propTypes = {
    branchIoLink: PropTypes.string,
    primaryColor: PropTypes.string.isRequired,
    secondaryColor: PropTypes.string.isRequired,
    isAudienceAllowed: PropTypes.bool,
    isGameAudienceAllowed: PropTypes.bool,
    confirmMedia: PropTypes.func.isRequired,
    onPlayerJoin: PropTypes.func.isRequired,
    fetchTeamDefinition: PropTypes.func.isRequired,
    fetchMobileBranchIoLink: PropTypes.func.isRequired,
    gameId: PropTypes.string.isRequired,
    onPlayerEnteredGameByDirectLink: PropTypes.func.isRequired,
    saveUserDefinitions: PropTypes.func.isRequired,
    isLandingShowed: PropTypes.bool.isRequired,
    currentTeamDefinition: PropTypes.shape({
      leftTeamName: PropTypes.string,
      rightTeamName: PropTypes.string,
      playerDefinition: PropTypes.arrayOf(PropTypes.string),
      teamDefinition: PropTypes.shape({
        preselected: PropTypes.string,
        field: PropTypes.string,
        values: PropTypes.arrayOf(PropTypes.string),
      }),
    }).isRequired,
    currentGame: PropTypes.shape().isRequired,
    fetchingCurrentTeamDefinition: PropTypes.bool,
    ableToSendGiftsForFree: PropTypes.bool.isRequired,
    profile: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    isAudienceAllowed: false,
    isGameAudienceAllowed: null,
    fetchingCurrentTeamDefinition: false,
  }

  componentDidMount() {
    const {isGameAudienceAllowed, onPlayerEnteredGameByDirectLink, gameId} = this.props;

    if (!isGameAudienceAllowed) {
      onPlayerEnteredGameByDirectLink({appId, gameId});
    }

    this.props.fetchTeamDefinition({appId, gameId});
  }

  render() {
    const {
      branchIoLink,
      primaryColor,
      secondaryColor,
      isAudienceAllowed,
      currentTeamDefinition,
      fetchingCurrentTeamDefinition,
      confirmMedia,
      onPlayerJoin,
      fetchTeamDefinition,
      fetchMobileBranchIoLink,
      profile,
      saveUserDefinitions,
      isGameAudienceAllowed,
      ableToSendGiftsForFree,
      isLandingShowed,
      currentGame,
    } = this.props;

    if (isGameAudienceAllowed === null) {
      return <PulseLoader/>;
    }

    const {
      hasAlreadyJoined,
      leftTeam = {},
      playerLimit,
      rightTeam = {},
      startedState,
    } = currentGame;
    const shouldRedirectToLobby = !hasAlreadyJoined && !isAudienceAllowed
      && playerLimit <= (leftTeam.playersCount + rightTeam.playersCount);

    if (shouldRedirectToLobby) {
      forwardTo('/lobby');
      const forwardMessage = startedState === GAME_PHASE_PLAYING
        ? youCantJoinMessage
        : youCantJoinFullGameMessage;

      toast.error(forwardMessage, defaultToastProps);
    }

    return (
      <Panel
        title="Let’s get started!"
      >
        <div className="text-center join-game-container">
          <JoinGame
            branchIoLink={branchIoLink}
            saveUserDefinitions={saveUserDefinitions}
            onJoinGame={onPlayerJoin}
            onConfirmMedia={confirmMedia}
            isLandingShowed={isLandingShowed}
            currentGame={currentGame}
            color={secondaryColor}
            barColor={primaryColor}
            isAudienceAllowed={isAudienceAllowed}
            user={profile}
            currentTeamDefinition={currentTeamDefinition}
            fetchingCurrentTeamDefinition={fetchingCurrentTeamDefinition}
            fetchGameTeamDefinition={fetchTeamDefinition}
            fetchMobileBranchIoLink={fetchMobileBranchIoLink}
            ableToSendGiftsForFree={ableToSendGiftsForFree}
            redirect={false}
          />
        </div>
      </Panel>
    );
  }
}
